import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import {
  IOrganisationUserCareTeamAssignmentPreview,
  IPEPHealthService,
} from '@liquid-state/pephealth-client';
import doCreatePEPHealthService from '@redux/doCreatePEPHealthService';
import i18n from '../../i18n';
import {
  FetchOrganisationUserCareTeamAssignmentPreview,
  organisationUserCareTeamAssignmentPreviewFailed,
  organisationUserCareTeamAssignmentPreviewLoaded,
} from './actions';

export default function* organisationUserCareTeamPreviewRoot() {
  yield takeEvery('organisationUserCareTeamPreview/fetch', doFetchOrganisationUserCareTeamPreview);
}

function* doFetchOrganisationUserCareTeamPreview({
  payload: { organisationSlug, userId },
}: FetchOrganisationUserCareTeamAssignmentPreview) {
  try {
    const service: IPEPHealthService = yield call(doCreatePEPHealthService);
    const preview: IOrganisationUserCareTeamAssignmentPreview = yield call(
      service.getOrganisationUserCareTeamAssignmentPreview,
      organisationSlug,
      userId,
    );
    yield put(organisationUserCareTeamAssignmentPreviewLoaded(preview.assignments));
  } catch (err) {
    console.error(err);
    yield put(organisationUserCareTeamAssignmentPreviewFailed());
    yield call(message.error, i18n.t('common:careTeamAssignmentImpact.previewFailed'));
  }
}
